module.exports = __webpack_public_path__ + "assets/img/mingxi.60731e49.svg";